module.exports = __webpack_public_path__ + "static/media/shaff1185.c836c690.jpg";